function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(1 1)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  fill: "#EEF0F5",
  width: 34,
  height: 34,
  rx: 8.5
}), React.createElement("path", {
  d: "M10 22.052v2.533c0 .234.183.417.417.417h2.533a.39.39 0 00.292-.125l9.1-9.092-3.125-3.125-9.092 9.092a.41.41 0 00-.125.3zm14.758-8.683a.83.83 0 000-1.175l-1.95-1.95a.83.83 0 00-1.175 0l-1.525 1.525 3.125 3.125 1.525-1.525z",
  fill: "#000",
  fillRule: "nonzero"
}));

var SvgIcDetailsEdit = function SvgIcDetailsEdit(props) {
  return React.createElement("svg", _extends({
    width: 36,
    height: 36
  }, props), _ref);
};

export default __webpack_public_path__ + "7ed9fbabf2bf0129e451e86cf423b094.svg";
export { SvgIcDetailsEdit as ReactComponent };